import IconWrapper, { IconWrapperProps } from "@repo/ui/src/components/IconWrapper";

interface ExtendedIconProps extends IconWrapperProps {
  color?: string;
}

const CloseIcon = ({ color = "currentColor", ...rest }: ExtendedIconProps) => (
  <IconWrapper
    width="24"
    height="24"
    title="Close"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m20.485 4.929-1.414-1.414L12 10.585l-7.071-7.07-1.414 1.414 7.07 7.07-7.07 7.072 1.414 1.414 7.07-7.071 7.072 7.071 1.414-1.414L13.414 12l7.071-7.071Z"
      fill={color}
    />
  </IconWrapper>
);

export default CloseIcon;
